import { BankPayment } from "./bank-payment";
import { CardPayment } from "./card-payment";
import { CashPayment } from "./cash-payment";
import { CouponPayment } from "./coupon-payment";
import { GatewayPayment } from "./gateway-payment";
import { PaytmPaymentDto } from "./paytm-payment-dto";
import { SwipePayment } from "./swipe-payment";
import { UpiPayment } from "./upi-payment";
import { WalletPayment } from "./wallet-payment";


export class TransactionDetailPaymentsDto {

    refNo: number;
    headOfAccount: string;
    ledgerCode: string;
    ledgerType: string;
    amount: number;
    cashPayment: CashPayment;
    cardPayment: CardPayment;
    couponPayment: CouponPayment;
    bankPayment: BankPayment;
    upiPayment: UpiPayment;
    paytmPayment: PaytmPaymentDto;
    walletPayment: WalletPayment;
    swipePayment: SwipePayment;
    gatewayPayment: GatewayPayment;

    transactionNo: string;
    slNo: number;
    drAmount: number;
    crAmount: number;
    paymentType: string;

}
